import { Box } from "@mui/system";
import RecentTable from "./RecentTable/RecentTable";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectUserToken } from "../../../../../../../../features/userSlice";
import { useSearchParams } from "react-router-dom";
import { buiDashboardEndPointLogicMobile } from "../../../../../../../../logic/AssetManagement/overview/BusinessLeaderDashboardMobile/buiDashboardEndPointLogicMobile";
import {
  lastTwoWeeksQueryIdRecent,
  previousMonthQueryIdRecent,
} from "../../../helpers/QIDs";
import RecentSkeleton from "../../../helpers/RecentSkeleton";
import { setRecentFetchedForWorkspace } from "../../../../../../../../features/businessLeaderDashboardSlice";

const Recent = () => {
  const oauthTokenHeader = useSelector(selectUserToken) as any;
  const [searchParams] = useSearchParams();
  const websiteSharedUids = searchParams.get("workspace");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const { recentFetchedForWorkspace } = useSelector(
    (state: any) => state.businessLeaderDashBoard,
  );

  useEffect(() => {
    if (!oauthTokenHeader || !websiteSharedUids) return;
    if (recentFetchedForWorkspace === websiteSharedUids) return;
    const fetchData = async () => {
      try {
        setLoading(true);
        const dimensionResponse =
          await buiDashboardEndPointLogicMobile.getDimensionInBizLeaderDashboardMobile(
            oauthTokenHeader,
          );
        if (!dimensionResponse || dimensionResponse.status !== 200) {
          return;
        }
        const dimensions = dimensionResponse?.data?.data || [];
        const matchedDimensions = dimensions
          ?.filter((dim: any) =>
            dim.websites?.some(
              (site: any) => site.shared_uid === websiteSharedUids,
            ),
          )
          ?.map((dim: any) => dim.dimension);

        const dimensionsToUse =
          matchedDimensions?.length > 0
            ? matchedDimensions
            : dimensions?.length > 0
              ? [dimensions[0].dimension]
              : [];

        if (!dimensionsToUse.length) return;

        await Promise.all([
          buiDashboardEndPointLogicMobile.getRecentPreviousMonthQueryInBizLeaderDashboardMobile(
            {
              oauthTokenHeader,
              queryId: previousMonthQueryIdRecent,
              websiteSharedUids: websiteSharedUids?.split(",") || [],
              type: "site",
              dimension: dimensionsToUse,
            },
          ),
          buiDashboardEndPointLogicMobile.getRecentLastTwoWeeksQueryInBizLeaderDashboardMobile(
            {
              oauthTokenHeader,
              queryId: lastTwoWeeksQueryIdRecent,
              websiteSharedUids: websiteSharedUids?.split(",") || [],
              type: "site",
              dimension: dimensionsToUse,
            },
          ),
        ]);
        dispatch(setRecentFetchedForWorkspace(websiteSharedUids));
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [oauthTokenHeader, websiteSharedUids, recentFetchedForWorkspace]);

  return (
    <>
      <Box sx={{ px: 2 }}>{loading ? <RecentSkeleton /> : <RecentTable />}</Box>
    </>
  );
};

export default Recent;
